export class CDateTimeViewModel{
    fCurrentDateShamsi:string;
    fCurrentDayOfWeekShamsi:string;

    constructor(){
        this.fCurrentDateShamsi='';
        this.fCurrentDayOfWeekShamsi='';
    }
}